import { axiosNonAuthInstance } from "api/axios.instance"

class ResetPasswordService {
	static USERS = "users"

	async resetPassword(email: string) {
		return axiosNonAuthInstance.post(`${ResetPasswordService.USERS}/reset_password/`, {
			email,
		})
	}

	async resetPasswordConfirm(uid: string | null, password: string, token: string | null, reNewPassword: string) {
		return axiosNonAuthInstance.post(`${ResetPasswordService.USERS}/reset_password_confirm/`, {
			uid,
			new_password: password,
			token,
			re_new_password: reNewPassword,
		})
	}
}

export default new ResetPasswordService()
